// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__+h7iE","resultsStats":"styles_resultsStats__cHJ83"};